import { useId, useState } from "react";
import { FinanceDialog } from "../finance/FinanceDialog";
import { AppSelect } from "../components/inputs/AppSelect";
import { FieldRequirement } from "../components/FieldRequirement";
import { useLocale } from "../i18n";
import type { TeamRole } from "./TeamRoleEditor";

export function TeamMemberEditor({ partyId, version, member, roles, onClose, onSaved, onReload }: {
  partyId: string; version: number; member: { individualId: string; name: string; roles: { code: string }[] };
  roles: TeamRole[]; onClose: () => void; onSaved: () => void; onReload: () => void;
}) {
  const { w } = useLocale(); const id = useId();
  const [selected, setSelected] = useState(member.roles.map(role => role.code));
  const [active, setActive] = useState(true); const [reason, setReason] = useState("");
  const valid = Number.isSafeInteger(version) && version > 0 && selected.length > 0 && selected.length <= 3 &&
    selected.every(code => roles.some(role => role.code === code)) && !!reason.trim();
  return <FinanceDialog title={w("تعديل عضو الفريق", "Edit team member")} description={member.name}
    path={"/events/partyGroup/member?" + new URLSearchParams({ partyId, individualId: member.individualId })}
    method="PUT" payload={{ expectedVersion: version, roleCodes: selected, active, reason: reason.trim() }} valid={valid}
    onClose={onClose} onSaved={onSaved} onReload={onReload} submitLabel={active ? w("حفظ أدوار العضو", "Save member roles") : w("إنهاء عضوية الفريق", "End team membership")}>
    <label htmlFor={`${id}-roles`}>{w("أدوار العضو", "Member roles")} <FieldRequirement required /></label>
    <AppSelect id={`${id}-roles`} multiple required value={selected} onChange={setSelected} disabled={!active}>
      {roles.map(role => <option key={role.code} value={role.code}>{role.name}</option>)}
    </AppSelect>
    <label><input type="checkbox" checked={active} onChange={event => setActive(event.target.checked)} />{w("العضوية فعالة", "Membership active")}</label>
    <label htmlFor={`${id}-reason`}>{w("سبب التعديل", "Reason for change")} <FieldRequirement required /></label>
    <textarea id={`${id}-reason`} required maxLength={500} value={reason} onChange={event => setReason(event.target.value)} />
    <p className="muted">{w("يُحدّث هذا الإجراء عضوية الفريق الحالية. تبقى تشكيلات الجولات المعتمدة والأصوات والنتائج السابقة محفوظة.", "This updates current team membership. Prepared round rosters, votes and previous results are preserved.")}</p>
  </FinanceDialog>;
}
